<!--
  ~ Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->
@if (environment.isLocalProd) {
<span class="environment-localprod">DANGER: RUNNING PROD LOCALLY</span>
}
<og-header></og-header>
<div class="og-container">
  <main class="container__main">
    <router-outlet></router-outlet>
  </main>
</div>
